import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {OrdersTradesFilter} from '../../../model/clearing/orders-trades-filter';
import {CookieNames} from "../../../shared/cookie/cookie-names";
import {CrystalClearFrontUrl} from "../../../shared/pages/crystal-clear-front-url";
import {PageDescription} from "../../../shared/pages/page-description";
import {CCRoles, CCRolesType} from "../../../model/security/cc-roles-type";
import {Router} from "@angular/router";
import {ReportTask} from "../../../model/archive/report-task";
import {SessionNames} from "../../../shared/session/session-names";
import {AppConfigService} from 'src/app/services/app-config.service';
import {CcStorageService} from "../../../services/common/cc-storage.service";
import {FlexAddFormDialogComponent} from "../flex/flex-add-form-dialog/flex-add-form-dialog.component";
import {
  FlexAddOrdersFormDialogComponent
} from "../flex/flex-add-orders-form-dialog/flex-add-orders-form-dialog.component";
import StateFilter = OrdersTradesFilter.StateFilter;

@Component({
  selector: 'app-clearing-sidebar',
  templateUrl: './clearing-sidebar.component.html',
  styleUrls: ['./clearing-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class ClearingSidebarComponent implements OnInit {

  StateFilter = OrdersTradesFilter.StateFilter;

  filterToolbarClass: string = 'min-size';

  filterToolbarToggled: boolean = false;

  @Input()
  selectedOrderIds: string[] = [];
  @Input()
  tradeModeEnabled: boolean = false;

  @Input()
  ordersTradesFilter: OrdersTradesFilter;
  @Output()
  ordersTradesFilterChange = new EventEmitter<OrdersTradesFilter>();

  filtersFormVisible: boolean = false;

  transPartKey: string = 'page.clearing.filter.';

  menuItemsTop: MenuItem[] = [];
  menuItemsBottom: MenuItem[] = [];
  Origin = ReportTask.Origin;

  recapListDialogVisible: boolean = false;
  orderAmendmentListDialogVisible: boolean = false;
  isClearingAdmin: boolean = false;
  isRecapUser: boolean = false;
  hasRecapTask: boolean = false;
  isTotalResidualAdjustmentAdmin: boolean = false;

  @ViewChild('flexDialogAddForm')
  flexDialogAddForm: FlexAddFormDialogComponent;

  @ViewChild('flexDialogAddOrdersForm')
  flexDialogAddOrdersForm: FlexAddOrdersFormDialogComponent;

  hogoEnabled: boolean;

  constructor(private router: Router,
              private storageService: CcStorageService,
              private translateService: TranslateService,
              public appConfigService: AppConfigService) {
  }

  ngOnInit() {
    //load from cookies
    if (this.storageService.check(CookieNames.CLEARING_SIDE_BAR_MAXIMIZED)) {
      if (this.storageService.get(CookieNames.CLEARING_SIDE_BAR_MAXIMIZED) === 'true') {
        this.filterToolbarToggled = true;
      }
    }
    if (this.storageService.check(CookieNames.CLEARING_STATE_FILTER_SELECTED)) {
      const stateFilter: StateFilter = OrdersTradesFilter.StateFilter[this.storageService.get(CookieNames.CLEARING_STATE_FILTER_SELECTED)];
      this.ordersTradesFilter.stateFilter = OrdersTradesFilter.StateFilter[stateFilter];
      // this.changeState(OrdersTradesFilter.StateFilter[this.storageService.get(CookieNames.CLEARING_STATE_FILTER_SELECTED)]);
    }
    const roles = JSON.parse(sessionStorage.getItem(SessionNames.USER_ROLES));
    if (roles) {
      this.menuItemsTop = [
        this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_RECAP_LIST, roles, false, 'button-confirmation', [], () => {
          this.showRecapListDialog();
        }),
      ];
    }
    this.menuItemsBottom = [
      this.toMenuItem(CrystalClearFrontUrl.DATAAMENDMENT_ORDER_LIST, roles, false, 'button-orders-amendment', [], () => {
        this.showOrderAmendmentListDialog();
      })
    ];
    if (this.appConfigService.flexEnabled) {
      this.menuItemsBottom.push(
        this.toMenuItem(CrystalClearFrontUrl.CLEARING_FLEX_REQUEST, roles, false, 'button-upload-flex', [
          this.toMenuItem(CrystalClearFrontUrl.CLEARING_FLEX_ORDER_REQUEST, roles, false, 'button-upload-flex', [], () => this.showUploadFlexOrdersDialog()),
          this.toMenuItem(CrystalClearFrontUrl.CLEARING_FLEX_TRADE_REQUEST, roles, false, 'button-upload-flex', [], () => this.showUploadFlexTradesDialog()),
        ], undefined));
    }

    this.isClearingAdmin = this.isClearingAdmin_(roles);
    this.isRecapUser = this.isRecapUser_(roles);
    this.hasRecapTask = this.hasRecapTask_(roles);
    this.isTotalResidualAdjustmentAdmin = this.isTotalResidualAdjustmentAdmin_(roles);
    this.ordersTradesFilterChange.emit(this.ordersTradesFilter);
    this.hogoEnabled = this.appConfigService.hogoEnabled;
  }

  showRecapListDialog(): void {
    this.recapListDialogVisible = true;
  }

  showOrderAmendmentListDialog(): void {
    this.orderAmendmentListDialogVisible = true;
  }

  showUploadFlexTradesDialog(): void {
    this.flexDialogAddForm.showDialog();
  }

  showUploadFlexOrdersDialog(): void {
    this.flexDialogAddOrdersForm.showDialog();
  }

  // toggleFilterBarSize() {
  //   setTimeout(() => {
  //     this.filterToolbarToggled = !this.filterToolbarToggled;
  //     if (this.filterToolbarToggled) {
  //       this.filterToolbarClass = 'max-size';
  //     } else {
  //       this.filterToolbarClass = 'min-size';
  //     }
  //     // console.log('-----> this.filterToolbarClass ' + this.filterToolbarClass);
  //     // @ts-ignore
  //     // this.tradeOrders.ngAfterViewInit();
  //     // window.dispatchEvent(new Event('resize'));
  //     this.filterToolbarToggledChange.emit(this.filterToolbarToggled);
  //     this.storageService.set(CookieNames.CLEARING_SIDE_BAR_MAXIMIZED, this.filterToolbarClass);
  //
  //   });
  // }

  // showFiltersForm() {
  //   this.filtersFormVisible = true;
  // }

  changeState(stateFilter: StateFilter) {
    this.ordersTradesFilter.stateFilter = OrdersTradesFilter.StateFilter[stateFilter];
    this.ordersTradesFilterChange.emit(this.ordersTradesFilter);
    this.storageService.set(CookieNames.CLEARING_STATE_FILTER_SELECTED, this.ordersTradesFilter.stateFilter);
  }

  // // @HostListener('document:keyup.f3', ['$event'])
  // handleF3KeyboardEvent(event: KeyboardEvent) {
  //   if (!this.filtersFormVisible) {
  //     this.filtersFormVisible = true;
  //   }
  // }
  //
  // // @HostListener('document:keyup.f4', ['$event'])
  // handleF4KeyboardEvent(event: KeyboardEvent) {
  //   this.ordersTradesFilter.tradeFilters = [];
  //   this.ordersTradesFilter.orderFilters = [];
  //   this.ordersTradesFilterChange.emit(this.ordersTradesFilter);
  // }
  SizeChanged($event) {
    this.storageService.set(CookieNames.CLEARING_SIDE_BAR_MAXIMIZED, $event);
  }

  private toMenuItem(pDesc: PageDescription, roles: CCRolesType.Roles[], iconOnly: boolean, styleClass: string,
                     subItems: MenuItem[] = [], command?: (event?: any) => void): MenuItem {
    const menuItem = PageDescription.toMenuItem(pDesc, this.translateService,
      this.router, roles, iconOnly, subItems);
    if (command) {
      menuItem.command = command;
    }
    menuItem.styleClass = styleClass;
    return menuItem;
  }

  isClearingAdmin_(userRoles: CCRolesType.Roles[]): boolean {
    let isVisible: boolean = false;
    if (userRoles && CCRoles.ROLES_CLEARING_ADMIN) {
      userRoles.forEach(userRole => {
        if (CCRoles.ROLES_CLEARING_ADMIN.includes(userRole)) {
          isVisible = true;
        }
      });
    }
    return isVisible;
  }

  isRecapUser_(userRoles: CCRolesType.Roles[]): boolean {
    let isVisible: boolean = false;
    if (userRoles && CCRoles.ROLES_RECAP_LIST) {
      userRoles.forEach(userRole => {
        if (CCRoles.ROLES_RECAP_LIST.includes(userRole)) {
          isVisible = true;
        }
      });
    }
    return isVisible;
  }

  hasRecapTask_(userRoles: CCRolesType.Roles[]): boolean {
    let isVisible: boolean = false;
    if (userRoles && CCRoles.ROLES_ARCHIVE_RECAP_TASKS) {
      userRoles.forEach(userRole => {
        if (CCRoles.ROLES_ARCHIVE_RECAP_TASKS.includes(userRole)) {
          isVisible = true;
        }
      });
    }
    return isVisible;
  }

  isTotalResidualAdjustmentAdmin_(userRoles: CCRolesType.Roles[]): boolean {
    let isVisible: boolean = false;
    if (userRoles && CCRoles.ROLES_ARCHIVE_TOTAL_RESIDUAL_ADJUST) {
      userRoles.forEach(userRole => {
        if (CCRoles.ROLES_ARCHIVE_TOTAL_RESIDUAL_ADJUST.includes(userRole)) {
          isVisible = true;
        }
      });
    }
    return isVisible;
  }
}
